"use client";

import { ChartCard } from "@/components/ui/chart-card";
import { ScatterPlotSkeleton, LegendSkeleton } from "@/components/ui/chart-skeletons";

export default function CompetitiveBubbleSkeleton() {
  return (
    <ChartCard 
      title="Competitive Landscape"
      subtitle="Positioning map: Downloads (X) vs Revenue (Y). Bubble size = Review count. Color = Price tier."
    >
      <ScatterPlotSkeleton className="h-96" bubbleCount={7} />
      <div className="mt-3">
        <LegendSkeleton itemCount={4} layout="horizontal" showIcon={false} />
      </div>
    </ChartCard>
  );
}
